import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { RichText } from 'components';

export interface IRichTextWrapper extends FieldRenderProps<string> {}

const RichTextWrapper: React.FC<IRichTextWrapper> = (props) => {
  const { input, meta, label, ...otherProps } = props;
  return <RichText label={label} {...input} {...otherProps} />;
};

export default RichTextWrapper;
